import { createStringEnum, EnumValues } from '@lib/shared-interface-utility-types';

export const SecretName = createStringEnum([
    'cloudFrontSigningPrivateKey',
    'elasticsearchApiKey',
    'kajabiWebhookKey',
    'webhookKey',
]);
export type SecretName = EnumValues<typeof SecretName>;
